import type {
  CreateBedRequest,
  CreateRoomRequest,
  RoomServiceRequest,
  UpdateBedRequest,
  UpdateRoomRequest,
} from 'app/typings/core/admin/rooms/roomForm';
import type { Bed, Room } from 'app/typings/rooms';

export const mapRoomToCreateRequest = (room: Room): CreateRoomRequest => ({
  hotelId: room.hotelId,
  categoryId: room.categoryId,
  name: room.name,
  hasPrmAccess: room.hasPRM,
  area: room.area,
  roomServices:
    room.featureIds?.map(
      (feature: number): RoomServiceRequest => ({
        id: feature,
      })
    ) || [],
  categoryRoomCount: room.categoryRoomCount,
  beds:
    room.beds?.map(
      (bed: Bed): CreateBedRequest => ({
        categoryId: bed.categoryId || 0,
        isIncluded: bed.included || false,
        price: bed.price,
      })
    ) || [],
  pictures: room.pictures || [],
});

export const mapRoomToUpdateRequest = (room: Room): UpdateRoomRequest => ({
  categoryId: room.categoryId,
  name: room.name,
  hasPrmAccess: room.hasPRM,
  area: room.area,
  roomServices:
    room.featureIds?.map(
      (feature: number): RoomServiceRequest => ({
        id: feature,
      })
    ) || [],
  categoryRoomCount: room.categoryRoomCount,
  beds:
    room.beds?.map(
      (bed: Bed): UpdateBedRequest => ({
        id: bed.id,
        categoryId: bed.categoryId || 0,
        isIncluded: bed.included || false,
        price: bed.price,
      })
    ) || [],
  pictures: room.pictures || [],
});
